import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { AbwMatDatatableComponent } from './abw-mat-datatable.component';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import {ScrollingModule} from '@angular/cdk/scrolling';

@NgModule({
    declarations: [AbwMatDatatableComponent],
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ScrollingModule,
    ],
    exports: [AbwMatDatatableComponent]
})
export class AbwMatDatatableModule {}